import { Stack, ThemeProvider, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Slider } from '$comp/modals/video-player/slider'

const VoiceMetaTypography = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  color: theme.palette.white,
  ...theme.typography.body2,
}))

interface ControlBarProps {
  sliderValue: number
  onSliderValueChange: (value: number) => unknown
  spentDurationText: string
  audioDurationText: string
}

export function ControlBar({
  sliderValue,
  onSliderValueChange,
  spentDurationText,
  audioDurationText,
}: ControlBarProps) {
  return (
    <ThemeProvider theme={outerTheme => ({ ...outerTheme, direction: 'ltr' })}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          width: '100%',
          direction: 'ltr',
          padding: '0 12px 15px',
          boxSizing: 'border-box',
        }}
      >
        <Slider value={sliderValue} onChange={onSliderValueChange} />
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            overflow: 'hidden',
            direction: 'ltr',
            padding: '0 7px 0 0',
          }}
        >
          <VoiceMetaTypography>{spentDurationText}</VoiceMetaTypography>
          <VoiceMetaTypography
            sx={{
              color: 'white',
              margin: '0 4px',
            }}
          >
            /
          </VoiceMetaTypography>
          <VoiceMetaTypography>{audioDurationText}</VoiceMetaTypography>
        </Stack>
      </Stack>
    </ThemeProvider>
  )
}
